import { render, staticRenderFns } from "./original-email-message.vue?vue&type=template&id=5699c9a6&scoped=true"
import script from "./original-email-message.vue?vue&type=script&lang=js"
export * from "./original-email-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5699c9a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5699c9a6')) {
      api.createRecord('5699c9a6', component.options)
    } else {
      api.reload('5699c9a6', component.options)
    }
    module.hot.accept("./original-email-message.vue?vue&type=template&id=5699c9a6&scoped=true", function () {
      api.rerender('5699c9a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/settings/original-email-message.vue"
export default component.exports